let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("3wmvj")).then(() => parcelRequire('1iV2p'));